// Company legal-entity lists come from the API flagged with `is_default` and ordered newest first,
// so a company without a default falls back to its most recently created entity.
export function pickDefaultLegalEntity(legalEntities) {
  const entities = Array.isArray(legalEntities) ? legalEntities : []

  return entities.find(entity => entity.is_default) ?? entities[0] ?? null
}
